import { Injectable } from '@angular/core';

@Injectable()
export class ImageUrlService {

  private readonly BASE_PARAMS = 'utm_source=Hitchd&utm_medium=referral&utm_campaign=api-credit';

  // Gumlet hostname mappings
  private readonly HOSTNAME_MAPPINGS = {
    'hitchd-cdn.imgix.net': 'hitchd.gumlet.io',
    'hitchd-cdn2.imgix.net': 'hitchd.gumlet.io',
    'local-hitchd.imgix.net': 'kentand.gumlet.io'
  };

  getStandardImageUrl(baseUrl: string): string {
    if (!baseUrl) return '';
    const processedUrl = this.migrateToGumlet(this.cleanUrl(baseUrl));
    return `${processedUrl}?crop=entropy&fit=crop&w=1600&h=1040&q=75${this.BASE_PARAMS}`;
  }

  getHeroImageUrl(baseUrl: string): string {
    if (!baseUrl) return '';
    const processedUrl = this.migrateToGumlet(this.cleanUrl(baseUrl));
    return `${processedUrl}?crop=entropy&fit=crop&w=1600&h=1040&q=75${this.BASE_PARAMS}`;
  }

  getVideoPosterUrl(baseUrl: string): string {
    return this.getStandardImageUrl(baseUrl); // Same as standard for cache sharing
  }



  private cleanUrl(url: string): string {
    // Remove existing query parameters and hex values
    return url.split('?')[0].replace(/#[a-fA-F0-9]+$/, '');
  }

  migrateToGumlet(url: string): string {
    if (!url) return url;

    try {
      const urlObj = new URL(url);
      const currentHostname = urlObj.hostname;

      // Check if this is an Imgix hostname we want to migrate
      if (this.HOSTNAME_MAPPINGS[currentHostname]) {
        urlObj.hostname = this.HOSTNAME_MAPPINGS[currentHostname];
        return urlObj.toString();
      }

      // Return original URL if not an Imgix hostname
      return url;
    } catch (error) {
      // If URL parsing fails, return original URL
      console.warn('Failed to parse URL for Gumlet migration:', url, error);
      return url;
    }
  }

  // Simple domain migration without additional parameters
  migrateDomainOnly(url: string): string {
    if (!url) return url;

    try {
      const urlObj = new URL(url);
      const currentHostname = urlObj.hostname;

      // Check if this is an Imgix hostname we want to migrate
      if (this.HOSTNAME_MAPPINGS[currentHostname]) {
        urlObj.hostname = this.HOSTNAME_MAPPINGS[currentHostname];
        // Clear all search params to maintain original URL structure
        urlObj.search = '';
        return urlObj.toString();
      }

      // Return original URL if not an Imgix hostname
      return url;
    } catch (error) {
      // If URL parsing fails, return original URL
      console.warn('Failed to parse URL for domain migration:', url, error);
      return url;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/image-url.service.ts